export const additionalCountryList = [
    { id: 139, label: 'Liechtenstein', listKey: 'country' },
    { id: 99, label: 'France', listKey: 'country' },
    { id: 123, label: 'Italy', listKey: 'country' },
    { id: 49, label: 'Austria', listKey: 'country' },
    { id: 84, label: 'Germany', listKey: 'country' },
    { id: 73, label: 'Switzerland', listKey: 'country' },
];

export const additionalLanguageList = [
    { id: 235, label: 'English', listKey: 'language' },
    { id: 237, label: 'French', listKey: 'language' },
    { id: 236, label: 'Italian', listKey: 'language' },
    { id: 234, label: 'German', listKey: 'language' },
];
